const light = '#fff';
const grey = '#d7dfe1';
const dark = '#141413';
const disabledColor = '#ccc';
const backgroundColor = '#fff';

let primaryColor = '#d46d3b';
let primaryColorLight = '#e5744b';
let secondaryColor = '#384781';
let tercaryColor = '#babbb9';
let tercaryColorLight = '#eee';
let bodyColor = '#141413';
// let titleColor = null;
let titleColor = primaryColor;
let menuColor = null;

switch (process.env.REACT_APP_SITE) {
  case 'gsk_webconferences':
    menuColor = '#fff';
    break;
  default:
}

export {
  light,
  grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tercaryColor,
  tercaryColorLight,
  bodyColor,
  titleColor,
  menuColor,
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js